import { Theme, makeStyles } from '@material-ui/core';

import { colors } from '../../../assets';

export const useDatePickerStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'block',
    margin: 0,
    padding: 0,
    border: 'none',
    width: 320,
    maxWidth: 320,
    cursor: 'pointer',
    textAlign: 'left',

    '& label': {
      cursor: 'pointer',
    },

    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },

  dropdown: {
    zIndex: theme.zIndex.modal,
    width: ({ dropdownWidth }: { dropdownWidth?: number }) => dropdownWidth,
  },

  dropdownItem: {
    paddingRight: 15,
    whiteSpace: 'normal',
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: '24px',
    padding: '8px 16px',
    letterSpacing: '0.15px',
    overflow: 'hidden',

    '&:nth-child(even)': {
      backgroundColor: colors.grey10,
    },

    '&.Mui-selected': {
      backgroundColor: colors.grey30,
    },

    '&:hover, &.Mui-selected:hover': {
      backgroundColor: colors.grey20,
    },
  },

  readOnly: {
    pointerEvents: 'none',
  },

  inputEndAdornment: {
    fontSize: 16,
    color: colors.secondary.dark,
    marginRight: 16,
    marginLeft: 4,
    transformOrigin: 'center center',
    transform: 'translateY(-6px)',
  },
}));
